import { CodeValueType } from "../../Enums";

export class CodeListValue {
  static Sentinel: CodeListValue = new CodeListValue(
    0,
    CodeValueType.None,
    "",
    "",
    true,
    "",
    new Date(),
    1,
    new Date(),
    1,
    1,
    1
  );

  constructor(
    public id: number,
    public codeListId: CodeValueType,
    public name: string,
    public value: string,
    public disabled: boolean,
    public description: string,
    public created: Date,
    public createdBy: number,
    public lastUpdated: Date,
    public lastUpdatedBy: number,
    public parentCodeListValueId?: number,
    public sortOrder?: number
  ) {}
}

export class CodeListValueWithParent {
  public constructor(public value: CodeListValue) {}

  public createdBy: any; // no access to user model at this time
  public lastUpdatedBy: any; // no access to user model at this time
  public parent: CodeListValue;
}
